export default "__VITE_ASSET__CAQYZ$wh__"